// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as MediaApiModel$PorterinFeature from "../../../../shared/media/domain/api-models/MediaApiModel.mjs";
import * as SharedApiModel$PorterinFeature from "../../../../shared/core/domain/api-models/SharedApiModel.mjs";

function vehicle_attribute_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var vehicle_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_name"), null));
  if (vehicle_name.TAG === /* Ok */0) {
    var vehicle_image = MediaApiModel$PorterinFeature.image_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_image"), null));
    if (vehicle_image.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                vehicle_name: vehicle_name._0,
                vehicle_image: vehicle_image._0
              }
            };
    }
    var e = vehicle_image._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".vehicle_image" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = vehicle_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".vehicle_name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function vehicle_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = vehicle_attribute_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function vehicles_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.arrayFromJson(vehicle_data_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function callback_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var geo_region_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_id"), null));
  if (geo_region_id.TAG === /* Ok */0) {
    var show_callback = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "show_callback"), null));
    if (show_callback.TAG === /* Ok */0) {
      var callback_text = SharedApiModel$PorterinFeature.text_subtext_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "callback_text"), null));
      if (callback_text.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  geo_region_id: geo_region_id._0,
                  show_callback: show_callback._0,
                  callback_text: callback_text._0
                }
              };
      }
      var e = callback_text._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".callback_text" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = show_callback._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".show_callback" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = geo_region_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".geo_region_id" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function banner_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var image = MediaApiModel$PorterinFeature.image_src_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
  if (image.TAG === /* Ok */0) {
    var image_alt = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image_alt"), null));
    if (image_alt.TAG === /* Ok */0) {
      var service_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_name"), null));
      if (service_name.TAG === /* Ok */0) {
        var link = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "link"), null));
        if (link.TAG === /* Ok */0) {
          var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
          if (text.TAG === /* Ok */0) {
            var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
            if (sub_text.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        image: image._0,
                        image_alt: image_alt._0,
                        service_name: service_name._0,
                        link: link._0,
                        text: text._0,
                        sub_text: sub_text._0
                      }
                    };
            }
            var e = sub_text._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".sub_text" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = text._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".text" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = link._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".link" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = service_name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".service_name" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = image_alt._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".image_alt" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = image._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".image" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function promo_banner_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var geo_region_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_id"), null));
  if (geo_region_id.TAG === /* Ok */0) {
    var banner = Decco.arrayFromJson(banner_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "banner"), null));
    if (banner.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                geo_region_id: geo_region_id._0,
                banner: banner._0
              }
            };
    }
    var e = banner._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".banner" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = geo_region_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".geo_region_id" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function cmsAttributes_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var meta = SharedApiModel$PorterinFeature.meta_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "meta"), null));
  if (meta.TAG === /* Ok */0) {
    var callback = Decco.arrayFromJson(callback_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "callback"), null));
    if (callback.TAG === /* Ok */0) {
      var vehicles_info = vehicles_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicles_info"), null));
      if (vehicles_info.TAG === /* Ok */0) {
        var promo_banners = Decco.arrayFromJson(promo_banner_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "promo_banners"), null));
        if (promo_banners.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    meta: meta._0,
                    callback: callback._0,
                    vehicles_info: vehicles_info._0,
                    promo_banners: promo_banners._0
                  }
                };
        }
        var e = promo_banners._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".promo_banners" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = vehicles_info._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".vehicles_info" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = callback._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".callback" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = meta._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".meta" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function cmsData_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = cmsAttributes_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = cmsData_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  vehicle_attribute_decode ,
  vehicle_data_decode ,
  vehicles_info_decode ,
  callback_decode ,
  banner_decode ,
  promo_banner_decode ,
  cmsAttributes_decode ,
  cmsData_decode ,
  t_decode ,
}
/* No side effect */
